import GlobalNav from '@99designs/common/apps/global-nav/components/GlobalNav/GlobalNav';
import SiteFooter from '@99designs/common/apps/global-nav/components/SiteFooter/SiteFooter';
import SiteHeader from '@99designs/common/apps/global-nav/components/SiteHeader/SiteHeader';
import { Role } from '@99designs/common/apps/global-nav/consts';
import { Site } from '@99designs/common/apps/global-nav/lib/Site';
import loadable from '@loadable/component';
import Loading from 'common/Loading';
import React from 'react';

const Drawers = loadable(() =>
    import('@99designs/common/apps/global-nav/components/GlobalNavDrawers/GlobalNavDrawers')
);

interface LayoutProps {
    role: Role;
    site: Site;
    children: React.ReactNode;
}

function Layout({ children, role, site }: LayoutProps) {
    return (
        <GlobalNav>
            {({ toggleDrawer, drawerState }) => (
                <>
                    <SiteHeader
                        role={role}
                        site={site}
                        variations={['gradient']}
                        onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                        onRightDrawerTriggerClick={toggleDrawer('right', true)}
                    />
                    {children}
                    <Drawers
                        toggleDrawer={toggleDrawer}
                        role={role}
                        site={site}
                        drawerState={drawerState}
                        fallback={<Loading />}
                    />
                    <SiteFooter site={site} isFocused={true} />
                </>
            )}
        </GlobalNav>
    );
}

export default Layout;
